import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
function Plus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? colors.neutral700 : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.94 12.919v3.96h2v-3.96h3.939v-2h-3.94v-3.94h-2v3.94H6.98v2h3.96z",
    fill: color
  }));
}
export default Plus;